import request from "@/utils/request";

//获取验证码  1.注册验证码 2.私钥验证码
export const sMSAuthenticationCode = (data: any) =>
  request({
    url: "/Common/SMSAuthenticationCode",
    method: "post",
    data
  });
